import { render, staticRenderFns } from "./StockItemClassSelector.vue?vue&type=template&id=b20f037a&"
import script from "./StockItemClassSelector.vue?vue&type=script&lang=ts&"
export * from "./StockItemClassSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports